import { CSS_PX_PER_PT } from './particleBackgroundConfig';

/**
 * Grid dimensions from fixed CSS cell spacing, plus `overfillCellsPerSide` extra cells
 * beyond each viewport edge (cols += 2×overfill, rows += 2×overfill).
 */
export function gridDimensionsFromSpacingCssPt(
    viewportWidthFb: number,
    viewportHeightFb: number,
    devicePixelRatio: number,
    gridSpacingCssPt: number,
    overfillCellsPerSide: number,
): { cols: number; rows: number; particleCount: number } {
    const dpr = Math.max(1e-6, devicePixelRatio);
    const spacingCssPx = gridSpacingCssPt * CSS_PX_PER_PT;
    const wCss = viewportWidthFb / dpr;
    const hCss = viewportHeightFb / dpr;
    const interiorCols = Math.max(1, Math.floor(wCss / spacingCssPx));
    const interiorRows = Math.max(1, Math.floor(hCss / spacingCssPx));
    const o = Math.max(0, Math.floor(overfillCellsPerSide));
    const cols = interiorCols + 2 * o;
    const rows = interiorRows + 2 * o;
    return { cols, rows, particleCount: cols * rows };
}
